import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="container my-5">
      <h1 className="text-center mb-4 text-primary fw-bold">
        MarketMind4U – Terms & Conditions
      </h1>

      <section>
        <h>1. Introduction</h>
        <p>
          Welcome to <strong>MarketMind4U</strong>. These Terms and Conditions
          (“Terms”) govern your use of our website, services, and any related
          digital offerings. By accessing or using our platform, you agree to
          comply with these Terms in full. Please read them carefully before
          proceeding.
        </p>
      </section>

      <section>
        <h>2. Acceptance of Terms</h>
        <p>
          By using MarketMind4U, you confirm that you are at least 18 years of
          age and have the legal capacity to enter into a binding agreement. If
          you do not agree to these Terms, you must not access or use our
          Services.
        </p>
      </section>

      <section>
        <h>3. Services Overview</h>
        <p>
          MarketMind4U provides business development, digital marketing,
          By using MarketMind4U’s website or services, you agree that you are legally eligible to
           use our platform and to enter into this agreement. 
          If you do not agree with these Terms, please do not continue to use our services.
        </p>
      </section>

      <section>
        <h>4. Modification of Terms</h>
        <p>
          MarketMind4U reserves the right to update or modify these Terms at any
          time without prior notice. Updates will be posted on this page, and
          continued use of our Services indicates acceptance of any changes.
        </p>
      </section>

      <section>
        <h>5. User Responsibilities</h>
        <ul>
          <li>Provide accurate and updated business and contact information.</li>
          <li>Do not use our Services for unlawful or fraudulent purposes.</li>
          <li>
            Respect the intellectual property rights of MarketMind4U and third
            parties.
          </li>
          <li>
            Maintain confidentiality of any login credentials or client data
            shared during the course of service.
          </li>
        </ul>
      </section>

      <section>
        <h>6. Payments and Fees</h>
        <p>
          All payments for services must be made in advance as per the agreed
          quotation or package. Once payment is received, work will commence
          according to the defined service plan.
        </p>
      </section>

      <section>
        <h>7. No Refund Policy</h>
        <p>
          <strong>MarketMind4U follows a strict No Refund Policy.</strong>{" "}
          Payments once made for any service—whether digital marketing,
          promotion, or advertising—are non-refundable under any
          circumstances. Clients are encouraged to review all service details
          carefully before making a purchase.
        </p>
      </section>

      <section>
        <h>8. Intellectual Property</h>
        <p>
          All content, graphics, logos, software, and code on this website are
          owned by MarketMind4U. Unauthorized copying, reproduction, or
          redistribution is strictly prohibited. Clients retain ownership of
          their brand materials but grant us permission to use them for project
          execution and promotion.
        </p>
      </section>

      <section>
        <h>9. Limitation of Liability</h>
        <p>
          MarketMind4U shall not be held liable for any indirect, incidental, or
          consequential damages resulting from the use or inability to use our
          Services. While we aim to deliver optimal outcomes, we do not
          guarantee specific results due to variable market factors.
        </p>
      </section>

      <section>
        <h>10. Termination</h>
        <p>
          MarketMind4U reserves the right to suspend or terminate any user’s
          access to its Services if there is a violation of these Terms or any
          unethical business conduct.
        </p>
      </section>

      <section>
        <h>11. Privacy Policy</h>
        <p>
          Your use of our Services is also governed by our{" "}
          <a
            href="/privacy-policy"
            className="text-decoration-none fw-semibold text-primary"
          >
            Privacy Policy
          </a>
          , which outlines how we collect, use, and protect your information.
        </p>
      </section>

      <section>
        <h>12. Governing Law</h>
        <p>
          These Terms shall be governed and interpreted in accordance with the
          laws of India. All disputes shall be subject to the exclusive
          jurisdiction of the courts in Noida, Uttar Pradesh, India.
        </p>
      </section>
     

      <section>
        <h>13. Contact Us</h>
        <p>
          For questions regarding these Terms or our services, you may contact
          us at: <br />
          <strong>Email:</strong> 
             <a href="mailto:info@marketmind4u.com">     info@marketmind4u.com</a><br />          
          <strong>Phone:</strong> +91-7906576404 <br />
          <strong>Address:</strong> G07-Ground Floor-H-61,H Block , Noida Sector-63, Pincode-201309.
        </p>
      </section>

      <hr />
      <p className="text-center text-muted small mt-4">
        © {new Date().getFullYear()} MarketMind4U. All rights reserved.
      </p>
    </div>
  );
};

export default TermsAndConditions;
